import EsEnum from './EsEnum'


export const WSReqTypeEnum = new EsEnum([
    {code: 'OTHER', type: 99,desc: '其他',data:''||{}},
    {code: 'LOGIN', type: 1,desc: '请求登录二维码',data:''||{}},
    {code: 'HEARTBEAT',type: 2, desc: '心跳包',data:''||{}},
    {code: 'AUTHORIZE', type:3,desc: '登录认证',data:''||{}},
    {code: 'SUCCESSFULLY_CONNECTED', type:4,desc:'接入成功并更新用户信息',data:''||{}},
    {code: 'PAY_SUCCESS', type:11,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您有新的订单消息'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:12,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '订单支付成功'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:13,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您的订单已有供应商接单'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:15,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '已有供应商发送使用凭证'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:16,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '请您尽快付款'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:18,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您的订单已出行'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:19,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '点评成功'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:110,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '供应商回复成功'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:111,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您的订单超时未付，已关闭'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:112,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您已取消订单（未支付）'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:113,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您的订单不符合规则，交易关闭'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:114,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您的订单内容及金额已被供应商修改，请速速查看'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:115,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '因订单金额或数量已产生变更，您的订单暂时被锁定，请等待解锁消息及时付款'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:116,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '供应商已修改您客户所在的订单金额或数量，请及时更改价格，避免造成损失'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:116,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您所采用方案的定制师已修改自己的利润，请及时更改价格，避免造成损失'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:117,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您的订单已解锁，请及时付款'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:119,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '已有新的订单询单'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:419,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '您已成功提交订单询单'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:519,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '订单询单已产生报价，请您迅速调整价格，避免产生损失'
    },data:''||{}},
    {code: 'PAY_SUCCESS', type:619,url:"/myDeal",desc: '支付处理',msg:function(data) {
        return  '订单询单已产生产品，请您及时查看下单'
    },data:''||{}},
]);

